import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/';
/**
 *
 *
 */
export default {
  list(data) {
    return axios.get(userBastUrl + 'rawMaterial/list', {
      params: data
    });
  },
  addOrUpdate(data) {
    return axios.post(userBastUrl + 'rawMaterial/addOrUpdate', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  deleteItem(data) {
    return axios.post(userBastUrl + 'rawMaterial/deleteItem', qs.stringify(data));
  },
  groupStoreIn(data) {
    return axios.post(userBastUrl + 'productAssembleRecord/addOrUpdate', {
      params: data
    });
  },
  groupHistoryList(data) {
    return axios.get(userBastUrl + 'productAssembleRecord/list', {
      params: data
    });
  },
  groupHistoryExport(data) {
    return axios.post(userBastUrl + 'productAssembleRecord/export', {
      params: data
    });
  },
  operateStock(data) {
    return axios.post(userBastUrl + 'stock/operateStock', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  addOrUpdateTemplate(data) {
    return axios.post(userBastUrl + 'productAssembleTemplate/addOrUpdate', data, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  },
  listTemplate(data) {
    return axios.get(userBastUrl + 'productAssembleTemplate/list', {
      params: data
    });
  },
}
